module.exports = __webpack_public_path__ + "img/cooperation_1.71a236d6.png";